import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import usePerson from '../../hooks/usePerson';
import './PersonDetail.css';
import Footer from '../Footer';

const PersonDetail = () => {
  const { name } = useParams();
  const navigate = useNavigate();
  const { person, loading, error } = usePerson(name);

  const handleBackClick = () => {
    navigate('/team');
  };

  if (loading) {
    return (
      <div className="person-detail-page">
        <div className="loading-container">
          <div className="loading-spinner"></div>
          <p>Loading person details...</p>
        </div>
      </div>
    );
  }

  if (error || !person) {
    return (
      <div className="person-detail-page">
        <div className="error-container">
          <p>Person not found or failed to load: {error?.message}</p>
          <button onClick={handleBackClick} className="back-button">
            ← Back to Team
          </button>
        </div>
      </div>
    );
  }

  return (
    <>
    <div className="person-detail-page">
      <div className="person-header">
        <button onClick={handleBackClick} className="back-button">
          ← Back to Team
        </button>
        <h1>{person.name}</h1>
      </div>

      <div className="person-content">
        <div className="person-image">
          <img src={person.image} alt={person.name} />
        </div>

        <div className="person-info">
          <h2 className="person-title">{person.title}</h2>
          
          {person.bio && (
            <div className="person-bio">
              <h3>About</h3>
              <div 
                className="bio-text"
                dangerouslySetInnerHTML={{ __html: person.bio }}
              />
            </div>
          )}

          {person.projectsCategory && person.projectsCategory.length > 0 && (
            <div className="person-projects">
              <h3>Research Areas</h3>
              <div className="projects-list">
                {person.projectsCategory.map((project, index) => (
                  <span key={index} className="project-tag">
                    {project}
                  </span>
                ))}
              </div>
            </div>
          )}

          <div className="person-links">
            {person.email && (
              <a href={`mailto:${person.email}`} className="contact-link email">
                📧 {person.email}
              </a>
            )}
            {person.linkedin && (
              <a href={person.linkedin} target="_blank" rel="noopener noreferrer" className="contact-link linkedin">
                💼 LinkedIn
              </a>
            )}
            {person.website && (
              <a href={person.website} target="_blank" rel="noopener noreferrer" className="contact-link website">
                🌐 Website
              </a>
            )}
            {person.github && (
              <a href={person.github} target="_blank" rel="noopener noreferrer" className="contact-link github">
                💻 GitHub
              </a>
            )}
          </div>
        </div>
      </div>
    </div>
      <Footer />
      </>
  );
};

export default PersonDetail;
